<template> 
  <div id="app" :class="{'home-back':isHome}">
    <div v-if="isHome" class="home-back"  style="width:100%;min-width:1440px;height:100%;">
      <!-- background-image: url('http://album.usho.cn/www/upload/37e18db017f2dd8abe4cc7dcdf098717.png?imageView2/1/w/1013/h/468/q/10'), url('http://album.usho.cn/www/upload/f8b561ff7f9c9c57aca74200e91132c0.png'), url('http://album.usho.cn/www/upload/5218e3c0af0d8d63757cd03466501182.png'), url('http://album.usho.cn/www/upload/d2308a7248eb30a76af242adbbd2ef84.png'),url('http://album.usho.cn/www/upload/da0797ea079eaa4d1b362b23cad304ca.png'); -->
      <div class="aaa"><vHeader v-if="isNotLogin"/></div>
      <div style="width:100%;"></div>
      <router-view/>
      <vFooter v-if="isNotLogin"/>
      <div style="box-shadow: 0px 15px 15px 0px rgba(222, 228, 243, 0.49);">
          <!-- <div id="cs" @click="onCsClick">
            <div id="unread"></div>
            <img class="icon" src="http://album.usho.cn/www/upload/dd413b64d9b612cbe692f5315f52ee48.png" alt="校友、校友会、校友会系统（软件）、校友系统（软件）、校友企业（软件）、校友经济、知名校友、校友相册">
            <div id="cs-msg-box">
              <p id="welcome">嗨，欢迎回来，我能问你一个问题吗？</p>
              <span id="cs-ok" @click.stop="onCsOKClick">可以</span>
              <span id="cs-no" @click.stop="onCsNoClick">不可以</span>
            </div>
            <div id="cs-thank">
              好的，祝您愉快！
            </div>
          </div>
          <div id="close-cs" @click.stop="onColseCsClick">
            <img  src="http://album.usho.cn/www/upload/ae0b13193c631f3447a7e8ff073270c2.png" alt="校友、校友会、校友会系统（软件）、校友系统（软件）、校友企业（软件）、校友经济、知名校友、校友相册">
          </div>
          <div id="cs-video-box">
            <div id="close-cs-video" @click.stop="onCloseCsVideoClick"></div>
            <video id="cs-video" controls="">
              <source id="cs-video-source" src="">
            </video>
          </div> -->
        <div id="code" 
          @mouseover="mouseOver"
          @mouseleave="mouseLeave"
        >
          <p class="text">二维码</p>
          <div class="consult-wrap">
            <div class="consult-name">社汇小秘书：</div>
            <img class="qrcode" :src="'https://dl.sosho.cn/goserver/tool/qrcode?content='+config.url" alt="">
            <p class="consult-qq">微信扫码</p>
          </div>
        </div>
        <div id="phone">
          <p class="text">电话</p>
          <div class="consult-wrap">
            <div class="operation">友笑运营部：</div>
            <p class="operation-tel">Tel: 0571-86711325</p>
            <p class="online-time">在线时间: 9:00-18:00</p>
          </div>
        </div>
      </div>
      <iframe src="https://cs.sosho.cn/#/" scrolling="no" frameborder="0" id="kefu"></iframe>
    </div>
    <div v-else style="width:100%;height:100%">
      <div class="aaa"><vHeader v-if="isNotLogin"/></div>
      <div style="width:100%;"></div>
      <router-view/>
      <vFooter v-if="isNotLogin"/>
      <div style="box-shadow: 0px 15px 15px 0px rgba(222, 228, 243, 0.49);">
          <!-- <div id="cs" @click="onCsClick">
            <div id="unread"></div>
            <img class="icon" src="http://album.usho.cn/www/upload/dd413b64d9b612cbe692f5315f52ee48.png" alt="校友、校友会、校友会系统（软件）、校友系统（软件）、校友企业（软件）、校友经济、知名校友、校友相册">
            <div id="cs-msg-box">
              <p id="welcome">嗨，欢迎回来，我能问你一个问题吗？</p>
              <span id="cs-ok" @click.stop="onCsOKClick">可以</span>
              <span id="cs-no" @click.stop="onCsNoClick">不可以</span>
            </div>
            <div id="cs-thank">
              好的，祝您愉快！
            </div>
          </div>
          <div id="close-cs" @click.stop="onColseCsClick">
            <img  src="http://album.usho.cn/www/upload/ae0b13193c631f3447a7e8ff073270c2.png" alt="校友、校友会、校友会系统（软件）、校友系统（软件）、校友企业（软件）、校友经济、知名校友、校友相册">
          </div>
          <div id="cs-video-box">
            <div id="close-cs-video" @click.stop="onCloseCsVideoClick"></div>
            <video id="cs-video" controls="">
              <source id="cs-video-source" src="">
            </video>
          </div> -->


        <div id="code"   
          @mouseover="mouseOver"
          @mouseleave="mouseLeave"
        >
          <p class="text">二维码</p>
          <div class="consult-wrap">
            <div class="consult-name">社汇小秘书：</div>
            <img class="qrcode" :src="'https://dl.sosho.cn/goserver/tool/qrcode?content='+config.url" alt="">
            <p class="consult-qq">微信扫码</p>
          </div>
        </div>
        <div id="phone">
          <p class="text">电话</p>
          <div class="consult-wrap">
            <div class="operation">友笑运营部：</div>
            <p class="operation-tel">Tel: 0571-86711325</p>
            <p class="online-time">在线时间: 9:00-18:00</p>
          </div>
        </div>
      </div>
      <!-- <iframe src="https://cs.sosho.cn/#/" scrolling="no" frameborder="0" id="kefu"></iframe> -->
    </div>   
  </div> 
</template>

<script>

import vHeader from '@/components/v-header';
import vFooter from '@/components/v-footer';
import $ from "jquery";
const host = "https://api.sosho.cn";
export default {
  name: 'App',
  components:{
    vHeader,
    vFooter
  },
  data(){
    return{
      config:{}
    }
  },
  computed:{
    isHome(){
      return this.$route.path == '/'
    },
    isNotLogin(){
      return this.$route.path != '/login'
    }
  },
  watch:{
    
  },
  created(){
    this.getData();
  },
  mounted(){
    // this.showCustomerService = false;
		// let cs = document.getElementById("cs")
    // let csChat = document.getElementById("kefu")
		// let unread = document.getElementById("unread");
		// let csMsgBox = document.getElementById("cs-msg-box")
		// let closeCs = document.getElementById("close-cs")
		// let welcome = document.getElementById("welcome")
		// let csThank = document.getElementById("cs-thank")
		// let csVideoBox = document.getElementById("cs-video-box")
		// let csVideo = document.getElementById("cs-video")		
    // addEventListener('message',function(e){	
		// 	if(e.data.type=='login'){				
		// 		welcome.innerHTML = e.data.message
		// 		csMsgBox.style.display = 'block'
		// 		unread.innerHTML = 1
		// 		unread.style.display = 'block'
		// 	}
		// 	if(e.data.type=='playVideo'){
		// 		csVideo.src = e.data.message
		// 		csVideoBox.style.display = 'block'
		// 		csVideo.load()
		// 		csVideo.play()
		// 	}
		// 	if(e.data.type=='newMsg'&&!this.showCustomerService){
		// 		let innerHTML = unread.innerHTML||0;
		// 		let unreadCount = parseInt(innerHTML)
		// 		unreadCount++
		// 		if(unreadCount>9){
		// 			unreadCount = '9+'
		// 		}
		// 		unread.innerHTML = unreadCount
		// 		unread.style.display = 'block'
		// 	}
    // })
  },
  methods:{
    getData(){
      $.ajax({
          type: "GET",
          url: host + "/operate/wxwork_customer_service?appkey=h5",
          success: (dataIn) => {
              // console.log(dataIn)
              if(dataIn.items.length > 0){
                  this.config = dataIn.items[0];
              }
          },
      })
    },
    mouseOver() {
      $('.consult-wrap').addClass("consult-wrapa");
      this.creatQrCode()
    },
    // 移出
    mouseLeave() {
      $('.consult-wrap').removeClass("consult-wrapa");
    },
    creatQrCode() {
      setTimeout(()=>{
        $('#qrCodeUrl22').text("");
        var qrcode = new QRCode('qrCodeUrl22', {
          text: this.config.url, // 需要转换为二维码的内容
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },200)
    },
    onCsClick(){
      let cs = document.getElementById("cs")
      let csChat = document.getElementById("kefu")
      let unread = document.getElementById("unread");
      let csMsgBox = document.getElementById("cs-msg-box")
      let closeCs = document.getElementById("close-cs")
      let welcome = document.getElementById("welcome")
      let csThank = document.getElementById("cs-thank")
      let csVideoBox = document.getElementById("cs-video-box")
      let csVideo = document.getElementById("cs-video")	


      this.showCustomerService = true;			
			unread.style.display = "none"
			unread.innerHTML = ''
			cs.style.display = 'none'	
			csMsgBox.style.display = 'none'	
			csChat.style.display = 'block'
			closeCs.style.display = 'block'			
			document.getElementById('kefu').contentWindow.postMessage('showchat','*')
    },
    onColseCsClick(event){
      let cs = document.getElementById("cs")
      let csChat = document.getElementById("kefu")
      let unread = document.getElementById("unread");
      let csMsgBox = document.getElementById("cs-msg-box")
      let closeCs = document.getElementById("close-cs")
      let welcome = document.getElementById("welcome")
      let csThank = document.getElementById("cs-thank")
      let csVideoBox = document.getElementById("cs-video-box")
      let csVideo = document.getElementById("cs-video")	


      this.showCustomerService = false;	
			closeCs.style.display = 'none'
			csChat.style.display = 'none'
			cs.style.display = 'block'		
			event.stopPropagation();
    },
    onCloseCsVideoClick(event){
      let cs = document.getElementById("cs")
      let csChat = document.getElementById("kefu")
      let unread = document.getElementById("unread");
      let csMsgBox = document.getElementById("cs-msg-box")
      let closeCs = document.getElementById("close-cs")
      let welcome = document.getElementById("welcome")
      let csThank = document.getElementById("cs-thank")
      let csVideoBox = document.getElementById("cs-video-box")
      let csVideo = document.getElementById("cs-video")	


      csVideo.load()
			csVideoBox.style.display = 'none'	
			event.stopPropagation();
    },
    onCsNoClick(event){
      let cs = document.getElementById("cs")
      let csChat = document.getElementById("kefu")
      let unread = document.getElementById("unread");
      let csMsgBox = document.getElementById("cs-msg-box")
      let closeCs = document.getElementById("close-cs")
      let welcome = document.getElementById("welcome")
      let csThank = document.getElementById("cs-thank")
      let csVideoBox = document.getElementById("cs-video-box")
      let csVideo = document.getElementById("cs-video")	

      csMsgBox.style.display = 'none'
			csThank.style.display = 'block'
			unread.style.display = "none"
			unread.innerHTML = ''
			setTimeout(function(){
				csThank.style.display = 'none'
			},2000)
			event.stopPropagation();
    },
    onCsOKClick(event){
      let cs = document.getElementById("cs")
      let csChat = document.getElementById("kefu")
      let unread = document.getElementById("unread");
      let csMsgBox = document.getElementById("cs-msg-box")
      let closeCs = document.getElementById("close-cs")
      let welcome = document.getElementById("welcome")
      let csThank = document.getElementById("cs-thank")
      let csVideoBox = document.getElementById("cs-video-box")
      let csVideo = document.getElementById("cs-video")	

      this.showCustomerService = true;		
			csMsgBox.style.display = 'none'
			cs.style.display = 'none'
			csChat.style.display = 'block'
			closeCs.style.display = 'block'
			unread.style.display = "none"
			unread.innerHTML = ''
			document.getElementById('kefu').contentWindow.postMessage('showchat','*')
			event.stopPropagation();
    }
  }
}
</script>

<style lang="less" >
.aaa{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}
.el-input__inner:focus {
  border-color: #35BDB2 !important;
  outline: 0;
}
.el-textarea__inner:focus {
  border-color: #35BDB2 !important;
  outline: 0;
}

.opacity{
  opacity:0
}
:root {
  --animate-delay: 0.3s !important;
}
*{
  margin:0;
  padding: 0;
}
html,body{
  width: 100%;
  height: 100%;
}
.home-back{
  //background-image: url('http://album.usho.cn/www/upload/c55b0ac6982e051c9e091bd2993f3c17.png?imageView2/1/w/916/h/555/q/10'), url('http://album.usho.cn/www/upload/f8b561ff7f9c9c57aca74200e91132c0.png'), url('http://album.usho.cn/www/upload/5218e3c0af0d8d63757cd03466501182.png'), url('http://album.usho.cn/www/upload/d2308a7248eb30a76af242adbbd2ef84.png'),url('http://album.usho.cn/www/upload/da0797ea079eaa4d1b362b23cad304ca.png');
  background-position-x: calc(50% + 335px), left,right,left,right;
  background-position-y: top,top,1050px,1848px,2716px;
  background-size:1270px 630px,330px 540px,166px 835px,240px 946px,285px 1259px;
  background-repeat: no-repeat,no-repeat,no-repeat,no-repeat,no-repeat;
  width: 1440px;
}
#app {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  #code{
    position: fixed;
    right:40px;
    bottom: 297px;
    width: 48px;
    height: 48px;
    z-index: 1000;
    background-color: #ffffff;
    border: 1px solid #EBEBEB;
    text-align: center;
    cursor: pointer;
    background: #ffffff url(http://album.usho.cn/www/upload/f876dfd9cc6ced8e369ce0aa694e31b2.png) no-repeat;
    background-size: 15px 15px;
    background-position-x: center;
    background-position-y: 10px;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius:8px 8px 0 0;
    .icon{
       width: 15px;
       margin-top:6px;
    }
    .text{
        color: #666666;
        font-size: 12px;
        margin-top:30px;
    }
    &:hover{
        background: #FF8844 url(http://album.usho.cn/www/upload/254fcbda3274a6d1de2827a753298713.png) no-repeat;
        background-size: 15px 15px;
        background-position-x: center;
        background-position-y: 10px;
        border: 1px solid #FF8844;
        .text{
            color: #ffffff;
        }
        // .consult-wrap{
        //     display: block;
        // } 
     }
    .consult-wrap{
        display: none;
        width: 200px;
        height: 200px;
        background-color: #fff;
        position: absolute;
        right: 60px;
        top: -70px;
        border: 1px solid #EBEBEB;
        box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
    }
    .consult-wrapa{
      display: block;
      .qrcode{
        width: 100px;
        height: 100px;
        margin: 30px auto 10px;
        display: block;
      }
    } 
    // .consult-wrap::after{
    //     // position: absolute;
    //     // content: '';
    //     // border-top: 10px transparent solid;
    //     // border-left: 10px solid #fff;
    //     // border-right: 10px transparent solid;
    //     // border-bottom: 10px transparent solid;
    //     // display: block;
    //     // right: -20px;
    //     // top: calc(50% - 5px);
    // }
    .consult-name{
        font-size: 13px;
        color: #333333;
        line-height: 16px;
        text-align: center;
        position: relative;
        top: 20px;
        left: 26%;
        transform: translate(-50%);
        text-indent: 24px;
        display: inline-block;
        background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUxpceHh4dnZ2dnZ2dnZ2dra2tnZ2dnZ2dra2tvb2////9ra2uLi4tra2tzc3NnZ2dra2tra2tra2tvb29ra2tra2tnZ2dra2tnZ2Q3QXb4AAAAYdFJOUwAM9erWp4v6xR8DoRTkSHRkfqwvloO9XuKz854AAACHSURBVAjXLY6JDsMgDEMDBAhQ6LnW//+lM92iKNLLZYuI1NVy1t3JG4vBg6nLiw29HEfpiJMKcI+7nQYU4gbkvfeUgY24A22UZTTgQ4xAemodHPP4hA/8y9XgcUqCuaTUTc5wicKmk8piUGlP+NtxYeOxs+uH1+1+QpH6ZSpMVzF4XVfNgd0vR/8HaEc4lzMAAAAASUVORK5CYII=') no-repeat left center/14px 14px;        
    }
    .consult-img{
        width: 100px;
        height: 100px;
        margin: 30px auto 10px;
        display: block;
    }
    .consult-qq{
        width: 100%;
        font-size: 16px;
        color: #FF8B48;
        line-height: 16px;
        text-align: center;
    }
  }
  #phone{
    position: fixed;
    right:40px;
    bottom: 248px;
    width: 48px;
    height: 48px;
    z-index: 1000;
    background-color: #ffffff;
    border: 1px solid #EBEBEB;
    text-align: center;
    cursor: pointer;
    background: #ffffff url(http://album.usho.cn/www/upload/a39ed775ba048e4c9af481dbfd22fdc5.png) no-repeat;
    background-size: 15px 15px;
    background-position-x: center;
    background-position-y: 10px;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0 0 8px 8px;
    .icon{
       width: 15px;
       margin-top:6px;
    }
    .text{
        color: #666666;
        font-size: 12px;
        margin-top:30px;
    }
    &:hover{
        background: #FF8844 url(http://album.usho.cn/www/upload/75eeb23055aa6e295f93d0332700b8f7.png) no-repeat;
        background-size: 15px 15px;
        background-position-x: center;
        background-position-y: 10px;
        border: 1px solid #FF8844;
        .text{
            color: #ffffff;
        }
        .consult-wrap{
            display: block;
        } 
     }
    .consult-wrap{
        display: none;
        width: 200px;
        height: 140px;
        background-color: #fff;
        position: absolute;
        right: 60px;
        top: -50px;
        border: 1px solid #EBEBEB;
        box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
    }
    .consult-wrap::after{
        position: absolute;
        content: '';
        border-top: 10px transparent solid;
        border-left: 10px solid #fff;
        border-right: 10px transparent solid;
        border-bottom: 10px transparent solid;
        display: block;
        right: -20px;
        top: calc(50% - 5px);
    }
    .operation-tel{
        margin-top: 28px;
        color: #FF8B48;
    }
    .operation{
        font-size: 13px;
        color: #333333;
        line-height: 16px;
        text-align: center;
        position: relative;
        top: 20px;
        left: 28%;
        transform: translate(-50%);
        text-indent: 24px;
        display: inline-block;
        background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUxpceHh4dnZ2dnZ2dnZ2dra2tnZ2dnZ2dra2tvb2////9ra2uLi4tra2tzc3NnZ2dra2tra2tra2tvb29ra2tra2tnZ2dra2tnZ2Q3QXb4AAAAYdFJOUwAM9erWp4v6xR8DoRTkSHRkfqwvloO9XuKz854AAACHSURBVAjXLY6JDsMgDEMDBAhQ6LnW//+lM92iKNLLZYuI1NVy1t3JG4vBg6nLiw29HEfpiJMKcI+7nQYU4gbkvfeUgY24A22UZTTgQ4xAemodHPP4hA/8y9XgcUqCuaTUTc5wicKmk8piUGlP+NtxYeOxs+uH1+1+QpH6ZSpMVzF4XVfNgd0vR/8HaEc4lzMAAAAASUVORK5CYII=') no-repeat left center/14px 14px;
    }
    .online-time{
        font-size: 13px;
        color: #B3B3B3;
        line-height: 14px;
        margin-top: 24px;
        text-align: center;
    }
  }
  #close-cs{
    display: none;
    position: fixed;
    right:40px;
    bottom: 40px;
    width: 48px;
    height: 48px;
    z-index: 1000;
    text-align: center;
    line-height: 58px;
    cursor: pointer;
    border-radius: 8px;
    box-shadow: 0px 3px 9px 0px rgba(0, 187, 173, 0.5);
    background-color: #fff;
    img{
       width: 21px;
       height: 21px; 
    }
  }

#cs-video-box{
    display: none;
    position: fixed;
    margin: 0px auto;
    z-index: 1001;
    top:200px;
    width: 600px;
    height: 350px;
    right:450px;
    box-shadow: 0px 3px 9px 0px rgba(0, 187, 173, 0.5);
}

#cs-video{
   width: 100%;
   height: 100%;
}

#close-cs-video{
    position:absolute;
    right: 10px;
    top:10px;
    width: 30px;
    height: 30px;
    z-index: 1002;
    background: url(http://album.usho.cn/www/upload/ae0b13193c631f3447a7e8ff073270c2.png) no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
}

#cs{
    display: block;
    position: fixed;
    right:40px;
    bottom: 40px;
    width: 48px;
    height: 48px;
    z-index: 1000;
    text-align: center;
    line-height: 58px;
    cursor: pointer;
    background: linear-gradient(136deg, #00D3BE 0%, #00CBC1 100%);
    border-radius: 8px;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    #cs-thank{
        display: none;
        background-color: #fff;
        position: absolute;
        right: 60px;
        bottom: 0px;
        border: 1px solid #EBEBEB;
        line-height: 30px;
        box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        text-align: left;
        padding:12px 20px;
        width: 130px;
    }
    #cs-thank::after{
        position: absolute;
        content: '';
        border-top: 10px transparent solid;
        border-left: 10px solid #fff;
        border-right: 10px transparent solid;
        border-bottom: 10px transparent solid;
        display: block;
        right: -20px;
        top: calc(50% - 5px);
    }
    #cs-msg-box{
        display: none;
        width: 200px;
        //height: 140px;
        background-color: #fff;
        position: absolute;
        right: 60px;
        top: -50px;
        border: 1px solid #EBEBEB;
        line-height: 30px;
        box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        text-align: left;
        padding:12px 20px;
        #welcome{
            font-size: 14px;
            color: #333333;
            
            font-weight: 800;
        }
        #cs-ok{
            display: inline-block;
            height: 25px;
            background: #00BBAD;
            border-radius: 13px;
            color: #ffffff;
            padding:5px 16px;
            box-sizing: border-box;
            line-height: 15px;
            font-size: 14px;
            margin-left:55px
        }
        #cs-no{
            display: inline-block;
            height: 25px;
            border: 1px solid #EBEBEB;
            border-radius: 13px;
            color: #00BBAD;
            padding:5px 16px;
            box-sizing: border-box;
            line-height: 15px;
            font-size: 14px;
        }

    }   
    #cs-msg-box::after{
        position: absolute;
        content: '';
        border-top: 10px transparent solid;
        border-left: 10px solid #fff;
        border-right: 10px transparent solid;
        border-bottom: 10px transparent solid;
        display: block;
        right: -20px;
        top: calc(50% - 5px);
    }
  }
  #unread{
      position:absolute;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #f94747;
      right:-6px;
      top:-6px;
      display: none;
      color: #ffffff;
      line-height: 16px;
      font-size: 10px;
  }
  #kefu{
			display: none;
      position: fixed;
      right: 40px;
      bottom: 100px;
      height: 544px;
      width: 352px;
      border:1px solid #f3f3f3;
      border-radius: 8px;
			z-index: 1000;
			box-shadow: 0px 10px 30px 0px rgba(134, 134, 134, 0.2);
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue